export default __webpack_public_path__ + "static/media/background-login.37759675.png";